export default process.env.NODE_ENV === 'production' ? 'https://sector3.verdedata.ro' : 'http://localhost:7155'
